<template>
  <div class="">
    <div class="layout wrap">
      <div class="flex xs4 px-1">
        <v-text-field
          label="Имя"
          v-model="item.name"
          :error-messages="errors.name"
        />
      </div>
      <div class="flex xs4 px-1">
        <v-select
          v-model="item.role"
          label="Роль"
          :error-messages="errors.role"
          :items="[
            { code: 'user', text: 'Пользователь' },
            { code: 'admin', text: 'Администратор' },
            { code: 'support', text: 'Support' }
          ]"
          item-value="code"
          item-text="text"
        />
      </div>
    </div>
    <div class="layout wrap">
      <div class="flex xs4 px-1">
        <v-text-field
          v-model="item.login"
          label="Логин"
          :error-messages="errors.login"
        />
      </div>
      <div class="flex xs4 px-1">
        <v-text-field
          v-model="item.password"
          :error-messages="errors.password"
          label="Пароль"
          type="password"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserForm",
  props: ["item"],
  data() {
    return {
      errors: {
        name: [],
        login: [],
        role: [],
        password: []
      }
    };
  },
  methods: {
    validateAll() {
      this.setServerErrors();
      this.errors.name =
        this.item.name.trim().length === 0 ? ["Заполните поле"] : [];
      this.errors.login =
        this.item.login.trim().length === 0 ? ["Заполните поле"] : [];
      return !(this.errors.name.length || this.errors.login.length);
    },
    setServerErrors(fields = {}) {
      for (const field of Object.keys(this.errors)) {
        this.errors[field] = fields[field] || [];
      }
    }
  }
};
</script>
